export default "__VITE_ASSET__sS8ypd$9__"